<template>
    <el-select
        v-if="mode == 'edit'"
        :ref="reference"
        v-model="tmpValue"
        filterable
        multiple
        remote
        :placeholder="prop.placeholder ? prop.placeholder : $l10n.__('Rechercher')"
        :remoteMethod="remoteMethod"
        :loading="loading"
        class="wp-10"
        @remove-tag="remove"
    >
        <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.fullName != '' ? item.fullName : item.email"
            :value="parseInt(item.id)"
        >
        </el-option>
    </el-select>
    <person-list v-else :list="options" />
</template>

<script>
import CfMixin from '../../../mixins/CustomfieldInputsMixins';
import MultipleMixin from '../../../mixins/MultipleInputsMixins';
import PersonList from 'vcomponents/utilities/PersonList.vue';

export default {
    components: {
        'person-list': PersonList,
    },
    mixins: [CfMixin, MultipleMixin],
    emits: ['update:modelValue', 'remove', 'error'],
    methods: {
        remoteMethod: _.debounce(function (query) {
            if (query !== '') {
                this.loading = true;

                // ajax method to get staffs
                this.$ajax.get(
                    `/rest/staffs/autocomplete`,
                    { q: query },
                    (response) => {
                        this.options = response;
                        this.loading = false;
                    },
                    (error) => {
                        this.close();
                        Push.error(this.$l10n.__('Problème lors de la récupération des données'));
                    },
                );
            } else {
                this.options = [];
            }
        }, 500),
        checkParams(newValue) {
            let valid = true;
            valid = this.checkMinMaxParams(newValue);
            return valid;
        },
    },
};
</script>
